// extracted by css-extract-rspack-plugin
export default {"tooltip":"B28OSWFCM2wqe7nj"};